export var computeRecordTypeOptions = function (entityTypes, selected) {
    if (selected === void 0) { selected = ''; }
    var options = entityTypes
        .map(function (_a) {
        var id = _a.id, label = _a.label;
        return ({
            label: label,
            value: id,
            selected: id === selected,
        });
    });
    // EntityTypeSelectOption has label as ReactNode, but we just created it above
    // where all these labels are string only, so we can safely coerce to string
    options.sort(function (a, b) { return a.label.localeCompare(b.label); });
    return options;
};
